// Default settings for the application
const defaultSettings = {
  themeMode: 'light',  // Default to light mode for the application
  keeniconsStyle: 'filled',  // Default to using filled KeenIcons style
  container: 'fixed', // Default container layout is set to fixed
  // NOTE: despite the name, this flag is the "Privacy Mode" toggle — when true,
  // currency amounts are masked as "*****" (see utils/FormatCurrency.js). Default
  // to false so prices are visible; users opt into masking via the user menu.
  showPrices: false,
};
export { defaultSettings };